// @flow
const Palette = {
  $gray: '#7e7e7e',
  $lighterGray: '#F5F5F5',
  $white: '#ffffff',
  $nightRider: '#333333',
  $gainsboro: '#dddcdc',
  $whiteSmoke: '#f6f6f6',
  $robinsEggBlue: '#00c8b3',
  $doveGray: '#6d6c6c',
  $victoria: '#4d4289',
  $mineShaft: '#333333',
  $kimberly: '#736c9f',
  $deluge: '#7563a8',
  $lemonGrass: '#A1A598',
  $gallery: '#efeeed',
  $dimGray: '#666666',
  $nobel: '#AFA9A3',
  $awaken: 'var(--color-brand-purple3-default, #4C0677)',
  $lightGray: '#322828',
  $darkerGray: '#696969',
  $borderLightGray: '#d8d8d8',
  $errorOrange: '#ff8c1a',
  $thunder: '#322828',
  $cloudy: '#afa9a3',
  $disabled: 'rgba(250, 250, 250, 0.2)',
  $scooter: '#3CCBDA',
  $freshEggplant: 'var(--color-brand-purple3-default, #4C0677)',
  $dustyGray: '#9B9B9B',
  $ecruWhite: '#F7F7EB',
  $cerisePink: '#DC2784',
  $black: '#000000'
}

const FontFamily = {
  light: 'Rational-Light',
  regular: 'Rational-Medium',
  medium: 'Rational-Medium'
}

const theme = {
  primary: {
    bgColor: Palette.$white
  },
  secondary: {
    bgColor: 'rgba(217, 217, 217, 0.1)',
    color: Palette.$gray
  },
  Template: {
    borderColor: Palette.$gallery
  },
  NavList: {
    color: Palette.$gray,
    activeBg: Palette.$whiteSmoke,
    activeBorder: Palette.$robinsEggBlue
  },
  NewPassword: {
    textColor: Palette.$gray,
    titleColor: Palette.$lightGray
  },
  EasyToken: {
    textColor: Palette.$gray,
    titleColor: Palette.$lightGray,
    purpleColor: Palette.$freshEggplant,
    lightGray: Palette.$borderLightGray
  },
  AddressInfo: {
    textColor: Palette.$gray
  },
  Account: {
    header: {
      bgColor: Palette.$whiteSmoke
    },
    bankInfo: {
      color: Palette.$gray
    },
    body: {
      bgColor: Palette.$white,
      color: {
        primary: Palette.$gray,
        secondary: Palette.$mineShaft
      },
      border: Palette.$gallery
    },
    footer: {
      bgColor: Palette.$white
    },
    font_primary: FontFamily.light,
    font_secondary: FontFamily.medium,
    color: Palette.$thunder
  },
  WithdrawalsSteps: {
    title: {
      fontFamily: FontFamily.medium
    },
    text: {
      fontFamily: FontFamily.light,
      color: Palette.$mineShaft
    },
    description: {
      color: Palette.$doveGray
    },
    bank: {
      borderColor: Palette.$gallery
    }
  },
  WithdrawalValue: {
    bankName: {
      fontFamily: FontFamily.medium,
      color: Palette.$mineShaft
    },
    label: {
      fontFamily: FontFamily.regular,
      color: Palette.$cloudy
    },
    input: {
      fontFamily: FontFamily.light
    }
  },
  CheckWithdrawal: {
    bankName: {
      fontFamily: FontFamily.medium,
      color: Palette.$mineShaft
    },
    bankDetails: {
      color: Palette.$doveGray,
      fontFamily: FontFamily.lightlightGray
    },
    notice: {
      color: Palette.$gray,
      fontFamily: FontFamily.light
    },
    description: {
      color: Palette.$doveGray
    },
    withdrawal: {
      fontFamily: FontFamily.light
    }
  },
  WithdrawalSuccess: {
    title: {
      fontFamily: FontFamily.medium
    },
    text: {
      fontFamily: FontFamily.light
    }
  },
  InvestorProfile: {
    titleColor: Palette.$lightGray,
    titleColorInative: Palette.$darkerGray,
    titleFontFamily: FontFamily.regular,
    textColor: Palette.$lightGray,
    textFontFamily: FontFamily.light,
    activeBgColor: Palette.$lighterGray,
    activeTitleColor: Palette.$freshEggplant
  },
  FinancialSituation: {
    titleColor: Palette.$lightGray
  },
  FinancialTransfer: {
    fontFamily: FontFamily.regular,
    fontLight: FontFamily.light,
    fontColor: Palette.$nightRider,
    titleColor: Palette.$lightGray,
    Auth: {
      textColor: Palette.$white,
      Authentication: {
        InputPassword: {
          Placeholder: {
            color: Palette.$kimberly
          },
          InputField: {
            color: Palette.$white,
            border: Palette.$deluge
          }
        },
        Button: {
          disabledBg: Palette.$disabled
        }
      }
    }
  },
  BankAccountList: {
    infoColor: Palette.$doveGray,
    titleColor: Palette.$nightRider,
    titleFont: FontFamily.regular
  },
  BankAccountForm: {
    textColor: Palette.$lightGray,
    infoColor: Palette.$cloudy,
    linkColor: Palette.$scooter
  },
  BrokerTransfer: {
    color: Palette.$lightGray,
    secondaryColor: Palette.$gray,
    fontFamily: FontFamily.light,
    secondaryFont: FontFamily.medium,
    borderColor: Palette.$gainsboro,
    itemColor: Palette.$gray,
    badgeBg: Palette.$victoria,
    badgeColor: Palette.$white,
    purpleColor: Palette.$freshEggplant
  },
  TransferSecurity: {
    subtitleColor: Palette.$gray,
    titleColor: Palette.$lightGray,
    fontFamily: FontFamily.regular,
    fontLight: FontFamily.light,
    fontColor: Palette.$gray,
    Table: {
      bgColor: Palette.$whiteSmoke,
      color: Palette.$dimGray,
      Thead: {
        bgColor: Palette.$gallery,
        color: Palette.$dimGray
      },
      Button: {
        bgColor: Palette.$gallery,
        color: Palette.$nobel
      }
    }
  },
  AccountStatement: {
    subtitleColor: Palette.$gray,
    fontFamily: FontFamily.regular,
    fontLight: FontFamily.light,
    fontColor: Palette.$gray,
    values: Palette.$lightGray,
    valuesTitle: Palette.$dimGray,
    errorColor: Palette.$errorOrange
  },
  PersonalInfo: {
    fontRegular: FontFamily.regular,
    fontLight: FontFamily.light,
    fontColor: Palette.$lightGray
  },
  Chat: {
    bannerChatBgColor: Palette.$victoria,
    bannerFAQBgColor: '#A1A598'
  },
  Educational: {
    bannerYouTubeBgColor: Palette.$victoria,
    bannerLopesFilhoBgColor: Palette.$lemonGrass,
    bannerFontColor: Palette.$white,
    fontRegular: FontFamily.regular,
    fontLight: FontFamily.light,
    fontColor: Palette.$nightRider
  },
  IncomeReport: {
    fontColor: Palette.$thunder,
    titleFontFamily: FontFamily.regular,
    borderColor: Palette.$borderLightGray
  },
  Notifications: {
    black: Palette.$black,
    fontRegular: FontFamily.light
  },
  RecoveryElectronicSignature: {
    titleColor: Palette.$lightGray,
    titleFamily: FontFamily.$medium,
    subtitleColor: Palette.$lightGray,
    subtitleFamily: FontFamily.$light,
    disabledColorButton: Palette.$disabled
  },
  CustodyTransfer: {
    black: Palette.$black,
    gray: Palette.$gray,
    purple: Palette.$awaken,
    purpleLight: Palette.$freshEggplant,
    white: Palette.$white,
    grayLight: Palette.$borderLightGray,
    dustyGray: Palette.$dustyGray,
    ecruWhite: Palette.$ecruWhite,
    borderColor: Palette.$gainsboro,
    textColor: Palette.$lightGray,
    grayFog: Palette.$gallery,
    grayThunder: Palette.$thunder,
    cerisePink: Palette.$cerisePink,
    fontLight: FontFamily.light,
    fontRegular: FontFamily.regular
  },
  Earnings: {
    borderColor: Palette.$borderLightGray
  }
}

export default theme
